export default __webpack_public_path__ + "static/media/background.fdbb8524.svg";